import AssignmentIcon from "@mui/icons-material/Assignment";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import Button from "@mui/joy/Button";
import Stack from "@mui/joy/Stack";

export type ReviewStatus =
  | "needs-review"
  | "metadata-reviewed"
  | "has-facts"
  | "fact-validated"
  | "needs-fact-review"
  | "all";

interface DocumentFiltersProps {
  readonly defaultReviewStatus: ReviewStatus;
  readonly onReviewStatusChange: (status: ReviewStatus) => void;
}

export default function DocumentFilters({
  defaultReviewStatus,
  onReviewStatusChange,
}: DocumentFiltersProps) {
  return (
    <Stack direction="row" spacing={3} alignItems="center">
      <Stack direction="row" spacing={1}>
        <Button
          variant={defaultReviewStatus === "needs-review" ? "solid" : "outlined"}
          color="neutral"
          size="sm"
          startDecorator={<AssignmentIcon />}
          onClick={() => onReviewStatusChange("needs-review")}
          sx={{
            minWidth: "180px",
            fontWeight: defaultReviewStatus === "needs-review" ? "600" : "400",
          }}
        >
          Waiting for metadata review
        </Button>
        <Button
          variant={defaultReviewStatus === "needs-fact-review" ? "solid" : "outlined"}
          color="neutral"
          size="sm"
          startDecorator={<FactCheckIcon />}
          onClick={() => onReviewStatusChange("needs-fact-review")}
          sx={{
            minWidth: "180px",
            fontWeight: defaultReviewStatus === "needs-fact-review" ? "600" : "400",
          }}
        >
          Waiting for fact check
        </Button>
        {defaultReviewStatus !== "needs-review" && defaultReviewStatus !== "needs-fact-review" && (
          <Button
            variant="plain"
            color="neutral"
            size="sm"
            onClick={() => onReviewStatusChange("all")}
          >
            Show all
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
